module.exports = __webpack_public_path__ + "img/traffic-shaping.460eda9b.png";